import { render, staticRenderFns } from "./editReceive.vue?vue&type=template&id=a4b6b3b4&scoped=true&"
import script from "./editReceive.vue?vue&type=script&lang=js&"
export * from "./editReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b6b3b4",
  null
  
)

export default component.exports